var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.344 1h-7.219a.662.662 0 0 0-.656.667c0 .368.294.666.656.666h6.563v17.334H1.313V2.333h6.562a.661.661 0 0 0 .656-.666A.662.662 0 0 0 7.875 1H.656A.662.662 0 0 0 0 1.667v18.666c0 .369.294.667.656.667h19.688a.661.661 0 0 0 .656-.667V1.667A.662.662 0 0 0 20.344 1M5 12.349c0 .173.068.33.18.444l4.888 5.023a.599.599 0 0 0 .864 0l4.889-5.023c.11-.114.179-.27.179-.444a.62.62 0 0 0-.611-.628.601.601 0 0 0-.432.184l-3.846 3.951V.628A.62.62 0 0 0 10.5 0a.62.62 0 0 0-.611.628v15.228l-3.846-3.951a.601.601 0 0 0-.432-.184.62.62 0 0 0-.611.628z",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSelectedIcon);
export default __webpack_public_path__ + "static/media/download-selected-icon.0c84fd84.svg";
export { ForwardRef as ReactComponent };